var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.subTitle))]),_c('login-btn-comp',{attrs:{"isDefault":true},on:{"handle-btn-click":_vm.handleClick}},[_vm._v(_vm._s(_vm.btnName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }